import { createRouter, createWebHistory } from 'vue-router'
import ResultsView from '../components/ResultsView.vue'
import LiveResultsView from '../components/LiveResultsView.vue'
import SplitsView from '../components/SplitsView.vue'
import ArResultsView from '../components/ArResultsView.vue'
import StatsView from '../components/StatsView.vue'
import RunnerStatsView from '../components/RunnerStatsView.vue'
import LoopsView from '../components/LoopsView.vue'
import TeamsView from '../components/TeamsView.vue'
import SegmentsView from '../components/SegmentsView.vue'
import RogainingView from '../components/RogainingView.vue'
import GpsView from '../components/GpsView.vue'
import FinishView from '../components/FinishView.vue'
import MetaKoronaView from '../components/MetaKoronaView.vue'
import DynamicResultsView from '../components/DynamicResultsView.vue'
import LiveBoardView from '../components/LiveBoardView.vue'
import CheckpointListView from '../components/CheckpointListView.vue'
import CheckpointView from '../components/CheckpointView.vue'

const routes = [
  {
    path: '/:eventAlias',
    name: 'Results',
    component: ResultsView
  },
    {
        path: '/live/:eventAlias',
        name: 'LiveResults',
        component: LiveResultsView
    },
    {
        path: '/splits/:eventAlias',
        name: 'Splits',
        component: SplitsView
    },
    {
        path: '/ar/:eventAlias',
        name: 'ArResults',
        component: ArResultsView
    },
    {
        path: '/stats/:eventAlias',
        name: 'Stats',
        component: StatsView
    },
    {
        path: '/stats/:eventAlias/:runnerNumber',
        name: 'RunnerStats',
        component: RunnerStatsView
    },
    {
        path: '/loops/:eventAlias',
        name: 'Loops',
        component: LoopsView
    },
    {
        path: '/teams/:eventAlias',
        name: 'Teams',
        component: TeamsView
    },
    {
        path: '/segments/:segmentId',
        name: 'Segments',
        component: SegmentsView
    },
    {
        path: '/rogaining/:eventAlias',
        name: 'Rogaining',
        component: RogainingView
    },
    {
        path: '/gps/:eventAlias',
        name: 'Gps',
        component: GpsView
    },
    {
        path: '/finish/:eventAlias',
        name: 'Finish',
        component: FinishView
    },
    {
        path: '/meta-korona/:eventAlias',
        name: 'MetaKorona',
        component: MetaKoronaView
    },
    {
        path: '/dynamic/:eventAlias',
        name: 'Dynamic',
        component: DynamicResultsView
    },
    {
        path: '/board/:eventAlias',
        name: 'LiveBoard',
        component: LiveBoardView
    },
    {
        path: '/checkpoint/:eventAlias',
        name: 'Checkpoints',
        component: CheckpointListView
    },
    {
        path: '/checkpoint/:eventAlias/:markerId',
        name: 'Checkpoint',
        component: CheckpointView
    },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
